import { AuthenticationServiceProvider } from '../authentication-service/authentication-service';
import { ConfigServiceProvider } from '../config-service/config-service';
import { DisplayServiceProvider } from '../display-service/display-service';
import { Events } from 'ionic-angular';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { LayoutServiceProvider } from '../layout-service/layout-service';
import { RankingServiceProvider } from '../../../ranking/services/ranking-service/ranking-service';
import { StorageServiceProvider } from '../storage-service/storage-service';
import { TextServiceProvider } from '../text-service/text-service';
import { TrackJS } from 'trackjs';
import { User, UsersServiceProvider } from '../users-service/users-service';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class PlayerServiceProvider {
  player: User = {} as User;
  account: Account = {} as Account;
  index: number;
  tmpName: string;
  photoUrl: string;
  playerPhoto: any;
  player$: BehaviorSubject<User>;

  constructor(
    private authenticationService: AuthenticationServiceProvider,
    private configService: ConfigServiceProvider,
    private displayService: DisplayServiceProvider,
    private events: Events,
    private layoutService: LayoutServiceProvider,
    private rankingService: RankingServiceProvider,
    private storageService: StorageServiceProvider,
    private usersService: UsersServiceProvider,
    public http: HttpClient,
    public textService: TextServiceProvider,
  ) {
    this.player$ = new BehaviorSubject({} as User);
  }

  load() {
    return Promise.all([this.loadPlayer(), this.loadAccount()]).catch((err) =>
      console.error(err),
    );
  }

  loadPlayer() {
    return new Promise((resolve, reject) => {
      this.http
        .get(this.configService.getUrl('player'))
        .toPromise()
        .then((response: User) => {
          this.storageService.setObject('player', response);
          this.displayService.setScreenType(response.params.type);
          this.layoutService.setLayoutType(response.params.type);
          this.textService.language = response.langKey;
          this.player = response;
          this.player$.next(response);
          resolve(response);
        })
        .catch((error) => {
          console.log(error)
          reject(error)
        });
    });
  }

  loadAccount() {
    return new Promise((resolve, reject) => {
      this.http
        .get(this.configService.getUrl('account'))
        .toPromise()
        .then((response: Account) => {
          this.account = response;
          this.storageService.setObject('account', this.account.authorities);
          TrackJS.configure({ userId: this.account.login || '' });
          resolve(response);
        })
        .catch((err) => reject(err));
    });
  }

  getRankings() {
    let playerId: number;
    let playerRankings = {};
    return new Promise((resolve, reject) =>
      this.storageService
        .getObject('player')
        .then((player: User) => {
          playerId = player.id;
          return this.rankingService.getRankings();
        })
        .then((rankings: any) => {
          for (let ranking in rankings) {
            playerRankings[ranking] = rankings[ranking][playerId];
          }
          resolve(playerRankings);
        }),
    );
  }

  changePassword(oldPassword: string, newPassword: string) {
    let params = new URLSearchParams();
    params.append('oldPassword', oldPassword);
    params.append('newPassword', newPassword);

    return this.sendPasswordChangeRequest(params);
  }

  changePhoto(image) {
    return new Promise((resolve, reject) => {
      this.authenticationService
        .getAccessToken()
        .then((token) => {
          fetch(image).then(response => response.blob()).then(blob => {
            const formData = new FormData();
            const file = new File([blob], "profile-photo.jpeg", { type: "multipart/form-data" });
            formData.append('photo', file);

            const headers = new HttpHeaders({'Authorization': `Bearer ${token}`});

            this.http.post(this.configService.getUrl('photoChange'),  formData, {
              headers
            }).subscribe(() => {
              Promise.all([this.load(), this.usersService.load()]).then(() => {
                        this.events.publish('player:photoChanged');
                        resolve();
                      });
            }, err => reject());
          });
        })
        .catch((err) => reject(err));
    });
  }

  deletePhoto(): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http
        .delete(this.configService.getUrl('photoChange'))
        .toPromise()
        .then(() => {
          Promise.all([this.load(), this.usersService.load()]).then(() => {
            this.events.publish('player:photoChanged');
            resolve();
          });
        })
        .catch((err) => {
          reject();
          console.error(err);
        });
    });
  }

  getPlayer(): Promise<User> {
    return this.storageService.getObject('player') as Promise<User>;
  }

  getPlayerProperty(): User {
    return this.player ? this.player : null;
  }

  getAccount(): Promise<Account> {
    return this.storageService.getObject('account') as Promise<Account>;
  }

  private sendPasswordChangeRequest(params) {
    return this.http
      .post(this.configService.getUrl('passwordChange'), params.toString(), {
        headers: {
          'Content-type': 'application/x-www-form-urlencoded; charset=utf-8',
        },
      })
      .toPromise();
  }
}

export interface Account {
  login: string;
  firstName: string;
  lastName: string;
  email: string;
  activated: boolean;
  langKey: string;
  authorities: string[];
}



// WEBPACK FOOTER //
// ./src/modules/core/services/player-service/player-service.ts